import * as React from "react";
const SvgFiRrTrailer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-trailer_svg__a)">
      <path
        fill="#062147"
        d="M23.04 18.72h-1.92V5.28a4.806 4.806 0 0 0-4.8-4.8H4.8A4.806 4.806 0 0 0 0 5.28v10.56a4.81 4.81 0 0 0 3.943 4.723 3.852 3.852 0 0 0 7.455.077H23.04a.96.96 0 1 0 0-1.92M4.8 2.4h11.52a2.88 2.88 0 0 1 2.88 2.88V12h-1.92V5.28a.96.96 0 1 0-1.92 0V12h-1.92V5.28a.96.96 0 1 0-1.92 0V12H9.6V5.28a.96.96 0 1 0-1.92 0V12H5.76V5.28a.96.96 0 1 0-1.92 0V12H1.92V5.28A2.88 2.88 0 0 1 4.8 2.4M1.92 15.84v-1.92H19.2v4.8h-7.802a3.854 3.854 0 0 0-7.404-.117A2.88 2.88 0 0 1 1.92 15.84m5.76 5.76a1.92 1.92 0 1 1 0-3.84 1.92 1.92 0 0 1 0 3.84"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-trailer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrailer;
